import { fetchData, postData } from 'api/services/mediaPlanning/utils';
import { ApiResponse } from './types';

export const DIGITAL_FAIR_VALUE_KEY = 'digital-fair-value';
export const DIVISIONS = 'divisions';

export const CAMPAIGN = 'campaign/v2';
export const CAMPAIGNv3 = 'campaign/v3';

export const getDivisions = async () => {
  return fetchData<
    ApiResponse<{
      divisions: string[];
    }>
  >(`/${CAMPAIGN}/${DIVISIONS}`);
};

export const getBrands = async (division: string) => {
  return fetchData<
    ApiResponse<{
      brands: string[];
    }>
  >(`/${CAMPAIGN}/brands?division=${division}`);
};

export const getCategories = async (division: string, brand: string) => {
  return fetchData<
    ApiResponse<{
      categories: string[];
    }>
  >(`/${CAMPAIGN}/categories?division=${division}&brand=${brand}`);
};

export const getPartners = async () => {
  return fetchData<
    ApiResponse<{
      partners: string[];
    }>
  >(`/${DIGITAL_FAIR_VALUE_KEY}/partners`);
};

export const getChannels = async (accessType: 'full' | 'partial') => {
  return fetchData<
    ApiResponse<{
      channels: Array<{ channel: string; benchmark: string }>;
    }>
  >(`/${DIGITAL_FAIR_VALUE_KEY}/channels?accessType=${accessType}`);
};

export const verifyDigitalFairValue = async (body: {
  currentStep: number;
  brandNames: string[];
  category: string;
  campaignName: string;

  divisionNames: string;
  // partnerName: string;
  // startDate: string;
  // endDate: string;
  // campaignPeriod: string;
  // isDedIssued: boolean;
  // isFullSalesDataReceived: boolean;
  // dashboardExcel: string;
  // isRoasConfirmed: boolean;
  // fullAccessChannels?: Array<{
  //   id: string;
  //   channelName: string;
  //   dashboardLink: string;
  //   accessOwner: string;
  //   digitalConsultant: string;
  // }>;
  // partialAccessChannels?: Array<{
  //   id: string;
  //   channelName: string;
  //   impr?: number;
  //   cpm?: number;
  //   cost?: number;
  //   clicks?: number;
  //   cpc?: number;
  //   numberOfDays?: number;
  // }>;
}) => {
  return postData<
    ApiResponse<{
      errors: Array<{
        rowId: string;
        channelName?: string;
        fields?: Array<string>;
      }>;
      isVerify: boolean;
      transactionId: string;
    }>
  >(`/${DIGITAL_FAIR_VALUE_KEY}/verify?step=${body.currentStep}`, body);
};
